// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gameplay.is-full-page.has-top-header[data-v-367c531b] {\n  top: 0;\n  bottom: var(--magic-bottom-navigation-height, 64px);\n}\n\n.icons[data-v-367c531b] {\n  --magic-space--x-small: 12px;\n  background: var(--magic-tertiary, #311261);\n}\n.is-fullscreen .icons[data-v-367c531b], .icons.is-fullscreen[data-v-367c531b] {\n  background: var(--magic-tertiary, #311261);\n}", ""]);
// Exports
module.exports = exports;
